<script setup lang="ts">
const toaster = { position: 'top-center' as const, expand: false, progress: false }

useWreadiaSeo();
useScriptUmamiAnalytics();
</script>
<template>
  <NuxtRouteAnnouncer/>
  <UApp :toaster="toaster">
    <NuxtLayout>
      <NuxtPage/>
      <ConsentBanner />
    </NuxtLayout>
  </UApp>
</template>
